import React from 'react';
import { ModelTier, ModelDropdown } from './ChatBoxInput';
import { AgentItem, AgentPreference, HIDDEN_MODEL_DROPDOWN_AGENT_IDS } from './agentsModalTypes';
import { getAgentModelOptions } from './agentsModalUtils';

interface AgentRowProps {
  agent: AgentItem;
  preference: AgentPreference;
  toggleDisabled: boolean;
  globallyDisabled: boolean;
  modelDisabled: boolean;
  onToggle: (agentId: string) => void;
  onModelChange: (agentId: string, modelTier: ModelTier) => void;
  showModelDropdown: boolean;
}

export const AgentRow: React.FC<AgentRowProps> = ({
  agent,
  preference,
  toggleDisabled,
  globallyDisabled,
  modelDisabled,
  onToggle,
  onModelChange,
  showModelDropdown,
}) => {
  const modelOptions = getAgentModelOptions(agent.id);
  const toggleId = `agent-toggle-${agent.id}`;
  const shouldShowModelDropdown = showModelDropdown && !HIDDEN_MODEL_DROPDOWN_AGENT_IDS.has(agent.id);

  return (
    <div
      className={`agents-modal__item${toggleDisabled ? ' agents-modal__item--locked' : ''}`}
      style={{ '--agent-accent': agent.accent } as React.CSSProperties}
    >
      <div className="agents-modal__item-copy">
        <span className="agents-modal__item-title-row">
          <span className="agents-modal__accent-dot" />
          <span className="agents-modal__item-title">{agent.label}</span>
          {globallyDisabled && (
            <span className="agents-modal__locked-badge agents-modal__locked-badge--global">Global Off</span>
          )}
          {!globallyDisabled && toggleDisabled && (
            <span className="agents-modal__locked-badge">Required</span>
          )}
        </span>
        <span className="agents-modal__item-description">{agent.description}</span>
        <span className="agents-modal__item-meta">{agent.source}</span>
      </div>

      <div className={`agents-modal__toggle-wrap${shouldShowModelDropdown ? '' : ' agents-modal__toggle-wrap--toggle-only'}`}>
        {shouldShowModelDropdown && (
          <div
            className="agents-modal__model-wrap"
            onClick={(e) => e.stopPropagation()}
            onDoubleClick={(e) => e.stopPropagation()}
          >
            <ModelDropdown
              value={preference.model_tier}
              onChange={(value: ModelTier) => onModelChange(agent.id, value)}
              menuPlacement="auto"
              disabled={modelDisabled}
              options={modelOptions}
            />
          </div>
        )}

        <label
          className="agents-modal__toggle-control"
          htmlFor={toggleId}
          aria-label={`${preference.enabled ? 'Disable' : 'Enable'} ${agent.label}`}
        >
          <input
            id={toggleId}
            type="checkbox"
            checked={preference.enabled}
            disabled={toggleDisabled}
            onChange={() => onToggle(agent.id)}
            className="plan-auto-checkbox"
          />
          <span className="plan-auto-slider" />
        </label>
      </div>
    </div>
  );
};
